.timelineDot::before {
  content: "";
  background: white;
  position: absolute;
  left: -1px;
  top: -9px;
  transform: translateX(-20%);
  -webkit-transform: translateX(-20%);
  width: 19px;
  height: 19px;
  border: 4px solid #1681f6;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  z-index: 10;
}

.content {
  position: relative;
  top: 7px;
  padding-top: 6px;
  padding-bottom: 0px;
}

.content::before {
  content: "";
  background: var(--timeline-callout-line-color, rgba(12, 52, 81, 0.3));
  position: absolute;
  top: 0;
  left: 4px;
  width: 2px;
  height: 15px;
}

.textNameOverflow {
  padding-top: 2px;
  padding-bottom: 2px;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  display: block;
}

.customTooltip {
  width: fit-content;
}